import { api } from '../core';

/**
 * One instructing company as returned by
 * `mermaidd/organisation/list-instructing-companies`. The response is
 * camelCased (matching the other /case endpoints).
 */
export interface InstructingCompany {
  instructingCompanyId: string;
  name: string;
}

export interface ListInstructingCompaniesResponse {
  companies: InstructingCompany[];
}

const listInstructingCompaniesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getListInstructingCompanies: builder.query<ListInstructingCompaniesResponse, void>({
      query: () => ({
        url: 'organisation/list-instructing-companies',
        method: 'GET',
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useLazyGetListInstructingCompaniesQuery, useGetListInstructingCompaniesQuery } =
  listInstructingCompaniesApi;
